import React, { PropsWithChildren } from 'react'
import { FormInputProps } from '../types'
import { RHFCheckbox } from './RHFCheckbox'
import { RHFDropdown } from './RHFDropdown'
import { RHFInput } from './RHFInput'
import { RHFPhoneNumberInput } from './RHFPhoneNumberInput'
import { RHFRadioButtons } from './RHFRadioButtons'

export interface InputsProps {
  inputs: FormInputProps[]
  readonly?: boolean
  formId?: string
}

const Margin = ({ children }: PropsWithChildren) => (
  <div className="first:mt-0 my-10 last:mb-0">{children}</div>
)

export const Inputs = ({ inputs, readonly, formId }: InputsProps) => (
  <div>
    {inputs.map(input => {
      const inputId = formId ? `${formId}-${input.slug}` : undefined

      switch (input.type) {
        default:
        case 'inputText':
        case 'inputEmail':
        case 'inputNumber':
        case 'inputPassword':
        case 'inputTextArea':
          return (
            <Margin key={input.slug}>
              <RHFInput id={inputId} input={input} readonly={readonly} />
            </Margin>
          )
        case 'inputDropdown':
          return (
            <Margin key={input.slug}>
              <RHFDropdown id={inputId} input={input} readonly={readonly} />
            </Margin>
          )
        case 'inputCheckbox':
          return (
            // Note: We omit setting a value for checkboxes. _Not_ setting a value will properly give a boolean
            // true/false result on submit.
            <RHFCheckbox
              id={inputId}
              input={input}
              key={input.slug}
              readonly={readonly}
            />
          )
        case 'inputRadioButtons':
          return (
            <Margin key={input.slug}>
              <RHFRadioButtons id={inputId} input={input} readonly={readonly} />
            </Margin>
          )
        case 'inputPhoneNumber':
          return (
            <Margin key={input.slug}>
              <RHFPhoneNumberInput id={inputId} input={input} readonly={readonly} />
            </Margin>
          )
      }
    })}
  </div>
)
